/* __next_internal_client_entry_do_not_use__ ToastIcon auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
export var ToastIcon = function(param) {
    var icon = param.icon;
    var _React_useState = _sliced_to_array(React.useState(typeof icon !== "string" ? icon : /*#__PURE__*/ _jsx(_Fragment, {})), 2), element = _React_useState[0], setElement = _React_useState[1];
    React.useEffect(function() {
        if (typeof icon !== "string") {
            setElement(icon);
            return;
        }
        var lazyload = undefined;
        var _icon_split = _sliced_to_array(icon.split(":"), 2), iconSet = _icon_split[0], iconName = _icon_split[1];
        switch(iconSet){
            case "legacy":
                lazyload = import("@faire/web--source/slate/icons/__generated__/icons");
                break;
            case "external":
                lazyload = import("@faire/web--source/slate/icons/__generated__/externalIcons");
                break;
            case "flags":
                lazyload = import("@faire/web--source/slate/icons/__generated__/flagsIcons");
                break;
            case "foundation":
                lazyload = import("@faire/web--source/slate/icons/__generated__/foundationIcons");
                break;
            case "foundationIllustrations":
                lazyload = import("@faire/web--source/slate/icons/__generated__/foundationIllustrationsIcons");
                break;
            case "paymentMethod":
                lazyload = import("@faire/web--source/slate/icons/__generated__/paymentMethodIcons");
                break;
        }
        if (lazyload) {
            lazyload.then(function(module) {
                var Icon = module[iconName];
                setElement(/*#__PURE__*/ _jsx(Icon, {
                    fontSize: "24px",
                    color: Core.icon.inverse
                }));
            });
        }
    }, [
        icon
    ]);
    return element;
};
